import { EbolDetails, EbolDetailsResponse, EBOL_SOURCE, ShipmentAttachment, EbolPhoto } from '../types/EbolDetails';

const preparePhotos = (photos: ShipmentAttachment[]): EbolPhoto[] => {
  return photos.map(photo => ({
    id: photo.id,
    name: photo.photo_type,
    picture_url: photo.picture_url,
    photo_type: photo.photo_type,
  }));
};

export const parseEbolDetailsResponse = (data: EbolDetailsResponse | null): EbolDetails | null => {
  if (!data) {
    return null;
  }
  const { ebol, shipment } = data;

  const photos = ebol.photos;

  if (ebol.source === EBOL_SOURCE.SHIPMENT_CONNECT && shipment) {
    const shipmentPhotos = preparePhotos(shipment.photos);
    photos.push(...shipmentPhotos);
  }

  return {
    ...ebol,
    photos,
  };
};

